export default __webpack_public_path__ + "static/media/BigClockIcon.8128f1e9.svg";